export default __webpack_public_path__ + "images/8f4bb5b4ac28f60b4fc178797e115095.svg";